import TypefaceMarquee from '@/components/global/TypefaceMarquee';

const TypefaceCardsWrapper = ({ blok }) => {
  const { cards, direction, speed } = blok;

  return <TypefaceMarquee cards={cards} direction={direction} speed={speed} />;
};

export default TypefaceCardsWrapper;
